import {Component} from "react";
import {Button, Col, Input, message, Modal, Row} from "antd";
import {CopyOutlined, DownloadOutlined} from "@ant-design/icons";
import copy from "copy-to-clipboard";

const {Password} = Input;

class DownloadPassword extends Component {

    handleCopyPassword = () => {
        if (this.props.password) {
            copy(this.props.password);
            message.success('Password copied to clipboard');
        }
    };

    handleDownloadCSV = () => {
        if (this.props.password) {
            const loginLink = `${window.location.origin}`
            const csvContent = `username,password,login_link\n${this.props.username},${this.props.password},${loginLink}`;

            const blob = new Blob([csvContent], {type: 'text/csv;charset=utf-8'});
            const url = URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            a.download = `${this.props.username}_password.csv`;

            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            URL.revokeObjectURL(url);
        }
    };

    render() {
        return (
            <Modal title="Get User Credentials"
                   visible={this.props.visible}
                   onOk={this.props.onOk}
                   onCancel={this.props.onCancel}>
                <Row gutter={16}>
                    <div style={{fontSize: 13}}>You can copy and download the user's password below.</div>
                    <br/>
                    <Col span={24}>
                        <div>Username:</div>
                    </Col>
                    <Col span={24}>
                        <Input
                            placeholder="Username"
                            value={this.props.username}
                            className="input-field"
                            autoComplete="username"
                            disabled
                        />
                    </Col>
                </Row>
                <Row gutter={16} style={{marginTop: 10}}>
                    <Col span={24}>
                        <div>Password:</div>
                    </Col>
                    <Col span={13}>
                        <Password
                            placeholder="Password"
                            value={this.props.password}
                            className="input-field"
                            autoComplete="new-password"
                        />
                    </Col>
                    <Col span={4}>
                        <Button onClick={this.handleCopyPassword}><CopyOutlined/></Button>
                    </Col>
                    <Col span={24}>
                        <div style={{fontSize: 11}}>This is the <span style={{fontWeight: 'bold'}}>only time
                            </span> you can view and download this password.
                        </div>
                    </Col>
                    <Col span={12} style={{marginTop: 20}}>
                        <Button onClick={this.handleDownloadCSV}
                                style={{borderColor: 'rgb(112,11,128)', color: 'rgb(112,11,128)', marginTop: 10}}>
                            <DownloadOutlined/>Download User Credentials
                        </Button>
                    </Col>
                </Row>
            </Modal>
        )
    }
}

export default DownloadPassword;